Object.defineProperty(exports, '__esModule', { value: true });
const prefix = 'fal';
const iconName = 'heading';
const width = 448;
const height = 512;
const aliases = ['header'];
const unicode = 'f1dc';
const svgPathData =
  'M0 48c0-8.8 7.2-16 16-16H80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H96V224H352V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V240 448h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V256H96V448h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V240 64H16C7.2 64 0 56.8 0 48z';

export default {
  prefix,
  iconName,
  icon: [width, height, aliases, unicode, svgPathData],
};
